"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.connectOptionallyAdvanced = exports.connectOptionally = void 0;
const react_redux_1 = require("react-redux");
const renderOptionally_1 = require("../components/renderOptionally");
const connectOptionallyMergeProps = (stateProps, dispatchProps, ownProps) => {
    if (!stateProps._toRender) {
        return stateProps;
    }
    else {
        const { _toRender, _props: prevStateProps } = stateProps;
        return {
            _toRender,
            _props: Object.assign({}, prevStateProps, dispatchProps, ownProps),
        };
    }
};
function connectOptionally(mapStateToProps, mapDispatchToProps) {
    return (WrappedComponent) => {
        return react_redux_1.connect(mapStateToProps, mapDispatchToProps, connectOptionallyMergeProps)(renderOptionally_1.renderOptionally(WrappedComponent));
    };
}
exports.connectOptionally = connectOptionally;
const connectOptionallyAdvanced = (selectorFactory, connectOptions) => (WrappedComponent) => {
    return react_redux_1.connectAdvanced(selectorFactory, connectOptions)(renderOptionally_1.renderOptionally(WrappedComponent));
};
exports.connectOptionallyAdvanced = connectOptionallyAdvanced;
